import { Box, Card, List, Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { ReactComponent as VeroSourceLogo } from '../../graphics/svg/verosource-logo.svg';

import SidebarItem from './SidebarItem';

function Sidebar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const path = pathname.split('/').at(2);

  return (
    <Card
      sx={{
        height: '100%',
        minWidth: '200px',
        maxWidth: '200px',
        borderRadius: 0,
      }}
    >
      <Stack
        spacing={3}
        sx={{
          height: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <List sx={{ pt: 2, pb: 0, width: '100%' }}>
          <SidebarItem
            name={t('components.sidebar.home')}
            icon="fa-house"
            path="home"
            selected={path === 'home'}
          />
          <SidebarItem
            name={t('components.sidebar.scenarios')}
            icon="diagram-project"
            path="scenarios"
            selected={path === 'scenarios'}
          />
        </List>
        <Box sx={{ height: '40px', pb: 2 }}>
          <VeroSourceLogo height={40} />
        </Box>
      </Stack>
    </Card>
  );
}

export default Sidebar;
